const _idGenerator = _IdGenerator();
export function generateId() {
    return _idGenerator.next().value;
}
function* _IdGenerator() {
    let id = 0;
    while (true)
        yield ++id;
}
